const FEATURE_FLAGS = {
  UP_NAVIGATION_FLAG: "upNavbar",
  NEW_ANALYTICS_FLAG: "showNewAnalytics",
  MEASURE_FLAG: "isMeasureLive",
  MANAGE_UNLOCKED_MENTIONS_FLAG: "showManageUnlockedMentions",
};

export { FEATURE_FLAGS };
